/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RemixContestUpdateNotificationAction } from './RemixContestUpdateNotificationAction';
import {
    RemixContestUpdateNotificationActionFromJSON,
    RemixContestUpdateNotificationActionFromJSONTyped,
    RemixContestUpdateNotificationActionToJSON,
} from './RemixContestUpdateNotificationAction';

/**
 * 
 * @export
 * @interface RemixContestUpdateNotification
 */
export interface RemixContestUpdateNotification {
    /**
     * 
     * @type {string}
     * @memberof RemixContestUpdateNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof RemixContestUpdateNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof RemixContestUpdateNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof RemixContestUpdateNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<RemixContestUpdateNotificationAction>}
     * @memberof RemixContestUpdateNotification
     */
    actions: Array<RemixContestUpdateNotificationAction>;
}

/**
 * Check if a given object implements the RemixContestUpdateNotification interface.
 */
export function instanceOfRemixContestUpdateNotification(value: object): value is RemixContestUpdateNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function RemixContestUpdateNotificationFromJSON(json: any): RemixContestUpdateNotification {
    return RemixContestUpdateNotificationFromJSONTyped(json, false);
}

export function RemixContestUpdateNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixContestUpdateNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(RemixContestUpdateNotificationActionFromJSON)),
    };
}

export function RemixContestUpdateNotificationToJSON(value?: RemixContestUpdateNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(RemixContestUpdateNotificationActionToJSON)),
    };
}

